import React from 'react';

const Maryland = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Maryland Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Disclosure/Disclaimer Statement: Sellers must provide one of these..
        </li>
        <li>HOA/Condo Association Disclosure: Required if applicable.</li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Maryland_Residential_Property_Disclosure_and_Disclaimer_Form.pdf',
                '_blank'
              );
            }}
          >
            Residential Property Disclosure and Disclaimer Statement{' '}
          </span>{' '}
          – Sellers must provide a disclosure form regarding the property's
          condition and defects before the buyer signs the purchase agreement.
        </li>
      </ol>
    </div>
  );
};

export default Maryland;
